export default class EpgPageHelpers {
  public static timeStampStartAndStopToWidthConverter = (
    startTimespan: number,
    endTimespan: number,
    firstHourTimelineTimestamp: number,
    hourInPixels: number,
  ) => {
    if (startTimespan < firstHourTimelineTimestamp)
      startTimespan = firstHourTimelineTimestamp;
    const durationInMinutes = Math.floor((endTimespan - startTimespan) / 60);
    // return width in pixel (duration in minutes * 4) - 4px margin-right
    return durationInMinutes * (1 / (60 / hourInPixels)) - 4;
  };
}
